export default "__VITE_ASSET__KlIZCQru__"